import { ITranslationRequest } from "../base/translation";

export interface IChildCat {
  id: number;
  name: string;
  percent: number;
}

export interface ICreateCategory {
  name: ITranslationRequest;
  note: ITranslationRequest;
  priority: number;
  order: number;
  parentId: number;
  percent: number;
  imageId: number;
  mainImageId: number;
  grandId: number;
  acceptedExchange: boolean;
  
}

export interface IUpdateCategory extends ICreateCategory {}

export interface IExportCategoryExcel {
  id: boolean;
  name: boolean;
  parent: boolean;
  order: boolean;
}
export const columnsCategory = ["name", "order", "id", "parent"];
